export enum POSPaperStatus {
    PRESENT = "PRESENT",
    NEAR_END = "NEAR_END",
    END = "END",
    UNKNOWN = "UNKNOWN",
}
